export { findPageByPath } from './findPageByPath';
export { hasViewRight } from './hasViewRight';

export { getContentStyle } from './getContentStyle';
